import { DialogM } from "@common/components/alert/dialog/Dialog"
import { theme } from "@common/theme/theme"
import { numberToWords } from "@data/utility/dataUtils"

export const onIsolatedAvatarPress = (liveStudents) => {
    if (liveStudents?.length === 1) {
        DialogM.show({
            champion: "zoe",
            variant: "main",
            text1: `Tu es le seul élève connecté`,
            buttonText1: "J'ai compris",
            buttonColor1: theme.colors.primary,
            onPress: () => {
                DialogM.hide()
            },
        })
        return
    }

    DialogM.show({
        champion: "tina",
        variant: "main",
        text1: `Tu partage ce live avec ${numberToWords(
            liveStudents?.length - 1,
        )} camarade${liveStudents?.length - 1 > 1 ? "s" : ""}`,
        text2: "Vous partagez le même tuteur, mais vous ne pouvez pas vous voir !",
        buttonText1: "J'ai compris",
        buttonColor1: theme.colors.primary,
        onPress: () => {
            DialogM.hide()
        },
    })
}